module.exports = __webpack_public_path__ + "static/icon-243aeade8350916a44cf0a3b66c62472.png";